import * as WebHIDActions from './webHID.reducer'

export const {
    showWebHIDPairButton,
    hideWebHIDPairButton,
    setWebHIDInCall,
    setIgnoreDeviceSignals,
    setConnectedHeadset,
} = WebHIDActions
